import React from 'react';
import { Box,  Container, Grid, Typography } from '@mui/material';
import './FirstSection.scss';
import UnifiedButton from '../../shared/Button';
import SpotifyIcon from '../../../assets/Images/spotify.svg';
import AppleMusicIcon from '../../../assets/Images/MusicPlaylist/apple music.svg'
import DeezerIcon from '../../../assets/Images/Deezer.svg';
import GaanaIcon from '../../../assets/Images/gaana.svg';
import { Slide } from 'react-awesome-reveal';
import { useNavigate } from 'react-router-dom';
// White wordmark — this strip sits on the dark hero gradient, and the
// dark-text variant of this logo was invisible against it.
import jiosavan from '../../../assets/Images/MusicPlaylist/jio savan.svg'
function FirstSection() {
    const navigate = useNavigate()

    const handleTryOnceClick = () => {
        navigate('/pricing');
    };


    const handleSeeAllPlatformClick = () => {
        navigate('/See-All-Platforms');
    };


    return (

        <Box className="first-section-landing-page">
            <Container maxWidth="lg">

                <Box className="content-wrapper">
                    <Slide direction="up" triggerOnce>
                        <Typography variant="h2" component="h1" className="title">
                            <span className="highlight">Release</span> Your Music
                            <br />
                            <span className="highlight">Everywhere</span>. Free. Always.
                        </Typography>
                        <Typography variant="h5" component="p" className="subtitle">
                            Unlimited, Free Music Distribution for Artists & Labels with FM Digital Official.
                        </Typography>
                        <Typography variant="body1" component="p" className="description">
                            The World's First Completely Free Music Distribution Platform.
                        </Typography>


                        <Box className="try-once-button">
                            <UnifiedButton
                                textContent="Try Once"
                                onClick={handleTryOnceClick}
                                className="try-once-button-landing"
                            />
                        </Box>


                        <Grid container spacing={1} justifyContent="flex-start" className="platform-logos">
                            <Grid item>
                                <img src={SpotifyIcon} alt="Spotify" className="platform-icon" />
                            </Grid>
                            <Grid item>
                                <img src={AppleMusicIcon} alt="Apple Music" className="platform-icon" />
                            </Grid>
                            <Grid item>
                                <img src={DeezerIcon} alt="Deezer" className="platform-icon" />
                            </Grid>
                            <Grid item>
                            <img src={jiosavan} alt="jiosavan" className="platform-icon" />
                            </Grid>
                            <Grid item>
                                <img src={GaanaIcon} alt="Gaana" className="platform-icon" />
                            </Grid>
                        </Grid>

                        <Box className="see-platforms-button">
                            <UnifiedButton
                                textContent="See All Platforms"
                                onClick={handleSeeAllPlatformClick}
                                className="see-platforms-button-landing"
                            />
                        </Box>
                    </Slide>
                </Box>

            </Container>
        </Box>

    );
}

export default FirstSection;